import { useRef, useState, useEffect } from "react";

const PersonalLife = ({ personalLife }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [showViewMore, setShowViewMore] = useState(false);
  const contentRef = useRef(null);
  const imageRef = useRef(null);

  useEffect(() => {
    const checkOverflow = () => {
      const isMobileOrTablet = window.innerWidth < 992;
      if (isMobileOrTablet && contentRef.current) {
        const contentHeight = contentRef.current.scrollHeight;
        setShowViewMore(contentHeight > 100);
      } else {
        setShowViewMore(false);
      }
    };

    checkOverflow();
    window.addEventListener("resize", checkOverflow);

    return () => {
      window.removeEventListener("resize", checkOverflow);
    };
  }, [personalLife]);

  if (!personalLife || !personalLife.content || !Array.isArray(personalLife.content)) {
    return (
      <div className="container">
        <div className="text-center p-4">
          <h1 className="display-6 fw-bold text-dark">Personal Life</h1>
          <p className="text-muted">No personal life data available.</p>
        </div>
      </div>
    );
  }

  const image = Array.isArray(personalLife.images) ? personalLife.images[0] : null;

  return (
    <div className="container">
      <div className="row">
        <div className="col-12 h-100">
          <div className="card-body p-0">
            <div className="text-center mb-5">
              <h1 className="display-6 fw-bold text-dark">Personal Life</h1>
            </div>
            <div className="row align-items-start">
              {image ? (
                <>
                  <div className="col-12 col-lg-5 mb-4 mb-lg-0">
                    <img
                      ref={imageRef}
                      src={image.url}
                      alt={image.alt || "Personal life image"}
                      className="img-fluid rounded shadow-sm w-100"
                    />
                  </div>
                  <div className="col-12 col-lg-7">
                    {personalLife.content.map((contentBlock, blockIndex) => (
                      <div key={blockIndex} className="mb-4">
                        {contentBlock?.heading && (
                          <h3 className="h4 fw-bold text-dark mb-3">
                            {contentBlock.heading}
                          </h3>
                        )}
                        <div
                          ref={blockIndex === 0 ? contentRef : null}
                          style={{
                            maxHeight:
                              !isExpanded && showViewMore && blockIndex === 0
                                ? "100px"
                                : "none",
                            overflow: blockIndex === 0 ? "hidden" : "visible",
                            transition: blockIndex === 0 ? "max-height 0.3s ease" : "none",
                            position: "relative",
                          }}
                        >
                          {contentBlock?.content?.map(
                            (paragraph, index) =>
                              paragraph && (
                                <p
                                  key={index}
                                  className="text-muted mb-3"
                                  style={{
                                    fontSize: "0.95rem",
                                    lineHeight: "1.6",
                                  }}
                                >
                                  {paragraph}
                                </p>
                              )
                          )}
                        </div>
                        {blockIndex === 0 && showViewMore && (
                          <button
                            className="btn btn-link p-0 mt-2"
                            onClick={() => setIsExpanded(!isExpanded)}
                            style={{
                              color: "#137CFF",
                              textDecoration: "none",
                              fontWeight: "500",
                              display: "block",
                              width: "100%",
                              textAlign: "left",
                            }}
                          >
                            {isExpanded ? "View Less" : "View More..."}
                          </button>
                        )}
                      </div>
                    ))}
                  </div>
                </>
              ) : (
                <div className="col-md-12">
                  {personalLife.content.map((contentBlock, blockIndex) => (
                    <div key={blockIndex} className="mb-4">
                      {contentBlock?.heading && (
                        <h3 className="h4 fw-bold text-dark mb-3">
                          {contentBlock.heading}
                        </h3>
                      )}
                      <div
                        ref={blockIndex === 0 ? contentRef : null}
                        style={{
                          maxHeight:
                            !isExpanded && showViewMore && blockIndex === 0
                              ? "100px"
                              : "none",
                          overflow: blockIndex === 0 ? "hidden" : "visible",
                          transition: blockIndex === 0 ? "max-height 0.3s ease" : "none",
                          position: "relative",
                        }}
                      >
                        {contentBlock?.content?.map(
                          (paragraph, index) =>
                            paragraph && (
                              <p
                                key={index}
                                className="text-muted mb-3"
                                style={{ fontSize: "0.95rem", lineHeight: "1.6" }}
                              >
                                {paragraph}
                              </p>
                            )
                        )}
                      </div>
                      {blockIndex === 0 && showViewMore && (
                        <button
                          className="btn btn-link p-0 mt-2"
                          onClick={() => setIsExpanded(!isExpanded)}
                          style={{
                            color: "#137CFF",
                            textDecoration: "none",
                            fontWeight: "500",
                            display: "block",
                            width: "100%",
                            textAlign: "left",
                          }}
                        >
                          {isExpanded ? "View Less" : "View More..."}
                        </button>
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PersonalLife;
